import React, { useState, useEffect } from 'react';
import { Button, VStack, Text, Box, useColorModeValue, HStack, Tooltip, Circle } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import { getUnreadItemTypes, getUnreadItemTypesByUserId } from '../services/api';

export default function EquipmentSelector({ onSelect, selected, equipmentList, isOpen, targetUserId }) {
  const { currentUser, isFunctionEnabled } = useAuth();
  const equipmentItems = equipmentList.equipment_types;

  const [unreadItemTypes, setUnreadItemTypes] = useState([]);

  useEffect(() => {
    const fetchUnreadItemTypes = async () => {
      // chat機能が無効な場合は未読通知を取得しない
      if (!isFunctionEnabled('chat')) {
        setUnreadItemTypes([]);
        return;
      }

      try {
        if (targetUserId) {
          const unreadItemTypes = await getUnreadItemTypesByUserId(targetUserId);
          setUnreadItemTypes(unreadItemTypes.item_types);
        } else {
          const unreadItemTypes = await getUnreadItemTypes();
          setUnreadItemTypes(unreadItemTypes.item_types);
        }
      } catch (error) {
        console.error('未読アイテムタイプの取得に失敗:', error);
        setUnreadItemTypes([]);
      }
    };

    // 初回実行
    fetchUnreadItemTypes();

    // chat機能が有効な場合のみ30秒ごとに実行
    if (isFunctionEnabled('chat')) {
      const intervalId = setInterval(fetchUnreadItemTypes, 30000);
      
      // クリーンアップ関数
      return () => clearInterval(intervalId);
    }
  }, [currentUser, targetUserId, isFunctionEnabled]);

  if (isOpen) {
    return (
        <VStack spacing={2} align="stretch">
          {Object.entries(equipmentItems || {}).map(([key, eq]) => {
            const isSelected = selected == key;
            // chat機能が無効な場合は未読表示しない
            const isUnread = isFunctionEnabled('chat') && unreadItemTypes.includes(key);
            return (
              <Tooltip 
                label={isUnread ? `${eq.hover_text}　※新着メッセージ有` : eq.hover_text} 
                hasArrow 
                placement="right" 
                isDisabled={!eq.hover_text && !isSelected} 
                key={key}
              >
                <Button
                  onClick={() => eq.enabled ? onSelect(key) : alert('現在開発中')}
                  bg="gray.50"
                  color="black"
                  fontWeight={isSelected ? 'bold' : 'normal'}
                  cursor={eq.enabled ? 'pointer' : 'not-allowed'}
                  mb={2}
                  w="100%"
                  fontSize="1.1em"
                  borderRadius="md"
                  boxShadow={eq.enabled ? 'sm' : 'none'}
                  transition="background 0.2s"
                  position="relative"
                  justifyContent="flex-start"
                  textAlign="left"
                  _active={eq.enabled ? { bg: isSelected ? 'white' : 'white' } : {}}
                >
                  {isUnread && (
                    <Circle
                      size="8px"
                      bg="yellow.700"
                      position="absolute"
                      left="3px"
                    />
                  )}
                  {eq.name}
                </Button>
              </Tooltip>
            );
          })}
        </VStack>
    );
  }
  return null;
}